import { all } from 'redux-saga/effects';
import { courtesiesSaga, imageApprovalSaga, jobsSaga, threeCardPendingSaga } from './admin';
import authSaga from './auth/saga';
import biopairsSaga from './biopairs/saga';
import { articleSaga, articlesSaga, categoriesSaga, relatedArticlesSaga, tagsSaga } from './blog';
import { astralChartSaga, bachFlowersSaga, chakrasSaga, crystalsSaga, nahualChartSaga, numerologySaga, quiromanciaSaga, runasSaga, sinastriaSaga, singleReadingSaga, suenosSaga, tarotSaga, threeCardReadingSaga } from './mystic';
import { countriesSaga, membershipsPeriodsSaga, newsSaga, specialtiesSaga } from './resources';
import { sendinblueContactsSaga, sendinblueFoldersSaga, sendinblueListSaga, sendinblueTemplatesSaga, sendinblueUtilitySaga } from './sendinblue';
import { couponsSaga, invoicesSaga, membershipsSaga, pricesSaga } from './shop';
import { publicStoreSaga } from './publicStore';
import therapistSaga from './therapist/saga';

export default function* rootSaga(getState) {
    yield all([
        authSaga(),
        biopairsSaga(),
        therapistSaga(),

        // admin
        imageApprovalSaga(),
        threeCardPendingSaga(),
        jobsSaga(),
        courtesiesSaga(),

        // resource
        newsSaga(),
        countriesSaga(),
        specialtiesSaga(),
        membershipsPeriodsSaga(),

        // sendinblue
        sendinblueListSaga(),
        sendinblueFoldersSaga(),
        sendinblueUtilitySaga(),
        sendinblueContactsSaga(),
        sendinblueTemplatesSaga(),

        // mystic
        tarotSaga(),
        singleReadingSaga(),
        threeCardReadingSaga(),
        bachFlowersSaga(),
        chakrasSaga(),
        numerologySaga(),
        astralChartSaga(),
        crystalsSaga(),
        suenosSaga(),
        runasSaga(),
        nahualChartSaga(),
        sinastriaSaga(),
        quiromanciaSaga(),

        // blog
        tagsSaga(),
        articleSaga(),
        articlesSaga(),
        categoriesSaga(),
        relatedArticlesSaga(),

        // shop
        pricesSaga(),
        couponsSaga(),
        invoicesSaga(),
        membershipsSaga(),

        // public store
        publicStoreSaga(),
    ]);
}
